/*  ==========================================================================
    CONTENTCLUSTER LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';
import moment from 'moment/src/moment';
import objectFitImages from 'object-fit-images';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// callback function
function callbackCcListView(container) {

    // object fit fix for older browsers (especially ie11)
    let images = $(container).find('img');
    objectFitImages(images, {
        watchMQ: true
    });

    // subtype slider
    if($(container).hasClass('bn-cc-list-view__type-slider')) {
        // slider initialization
        let sliderOverrides = {
                adaptiveHeight: true,
                autoplay: false,
                dots: false,
                fade: false,
                nextArrow: vars.slick_nextArrowV2,
                pauseOnHover: true,
                prevArrow: vars.slick_prevArrowV2,
            };
        utils.slickCarousel.initSingleSlider(container, sliderOverrides);

    }

    // subtype list
    if($(container).hasClass('bn-cc-list-view__type-list')) {

        // pagination
        // let $listPagiantion = $(container).find('.bn-cc-list-view__pagination'),
        //     $listPagiantionTrigger = $listPagiantion.find('.bn-button');
        // if($listPagiantion.length) {
        //     let offset = $listPagiantionTrigger.data('offset');
        //     $(container).data('cc_query-offset', offset);
        //     $listPagiantionTrigger.on('click', function() {
        //         $listPagiantion.remove();
        //         $(container).find('.bn-loader').removeClass('hidden');
        //         utils.contentclusterLoader.initCcService(container,callbackCcListView);
        //     });
        // }

    }

    if($(container).attr('data-type') === 'events') {
        let $container = $(container);
        // All Filter
        $container.find('.dna-all').on('click', function(){
            $container.find('.bn-no-result').addClass('hidden');
            $container.find('.dna-all').addClass('dna-act');
            $container.find('.dna-months div').each(function () {
                $(this).removeClass('dna-act');
            });
            $container.find('.dna-years div').each(function () {
                $(this).removeClass('dna-act');
            });
            $container.find('.dna-eventlist__items .dna-item').each(function() {
                $(this).removeClass('hidden');
            });
            $('.dna-eventlist .dna-eventlist__filter').removeClass('dna-act');
        });

        // Month Filter
        $container.find('.dna-months div').each(function () {
            $(this).on("click", function () {
                $container.find('.dna-all').removeClass('dna-act');
                $container.find('.dna-years div').each(function () {
                    $(this).removeClass('dna-act');
                });
                $container.find('.dna-months div').each(function () {
                    $(this).removeClass('dna-act');
                });

                $('.dna-eventlist .dna-eventlist__filter').removeClass('dna-act');

                let $month = $(this).data("month");
                $(this).addClass('dna-act');
                if(new Date().getFullYear() === 2020 && $month < 7) {  // corona -> no events
                    $container.find('.dna-eventlist__items .dna-item').each(function() {
                        $(this).addClass('hidden');
                    });
                } else {
                    $('.dna-eventlist .dna-eventlist__filter').removeClass('dna-act');

                    $container.find('.dna-eventlist__items .dna-item').each(function() {
                        $(this).removeClass('hidden');
                    });

                    $container.find('.dna-eventlist__items .dna-item:not([data-date="year"])').each(function() {
                        $(this).removeClass('hidden');
                        let $itemDate = moment($(this).data('date'), 'YYYY/MM/DD');
                        let $itemMonth = $itemDate.format('M');
                        if($month.toString() !== $itemMonth) $(this).addClass('hidden');
                    });
                }

                // No Result
                if ($container.find('.dna-eventlist__items .dna-item').length === $container.find('.dna-eventlist__items .dna-item.hidden').length) {
                    $container.find('.bn-no-result').removeClass('hidden');
                } else {
                    $container.find('.bn-no-result').addClass('hidden');
                }
            });
        });

        // Year Filter
        $container.find('.dna-years div').each(function () {
            $(this).on("click", function () {
                $container.find('.dna-all').removeClass('dna-act');
                $container.find('.dna-months > div').removeClass('dna-act');
                $container.find('.dna-years div').each(function () {
                    $(this).removeClass('dna-act');
                });

                $('.dna-eventlist .dna-eventlist__filter').removeClass('dna-act');

                let $year = $(this).data("year");
                $(this).addClass('dna-act');

                $container.find('.dna-eventlist__items .dna-item:not([data-date="year"])').each(function() {
                    //if($container.find('.dna-months div.dna-act').length < 1) {
                    $(this).removeClass('hidden');
                    //}
                    let $itemDate = moment($(this).data('date'), 'DD/MM/YYYY');
                    let $itemMonth = $itemDate.format('Y');
                    if($year.toString() !== $itemMonth) $(this).addClass('hidden');
                });

                // No Result
                if ($container.find('.dna-eventlist__items .dna-item').length === $container.find('.dna-eventlist__items .dna-item.hidden').length) {
                    $container.find('.bn-no-result').removeClass('hidden');
                } else {
                    $container.find('.bn-no-result').addClass('hidden');
                }
            });
        });

        $('.dna-eventlist .js-trigger').on('click', function () {
            $('.dna-eventlist .dna-eventlist__filter').addClass('dna-act');
        });
    }

}

// initialization
export function initCcListView($element) {
    let container = $element.find('.cc-service');

    // contentcluster service initialization (if element is in view)
    $element.one('inview', function() {
        if (container.attr('data-type') === 'news') {
            utils.rssLoader.initLoader(container, 'news', 'list', 'https://www.warmbaderhof.com/rss/bn/ajax?colpos=100', callbackCcListView);
        } else if (container.attr('data-type') === 'events') {
            utils.rssLoader.initLoader(container, 'events', 'list', 'https://www.warmbaderhof.com/rss-events/bn/ajax?colpos=100', callbackCcListView);
        }
    });
}



// WEBPACK FOOTER //
// ./source/js/modules/lib/cc-list-view.js